module.exports = "<a routerLink=\"/{{lang()}}/test-admin/dashboard\">\n  <tra slug=\"btn_back_to_dash\"></tra>\n</a>\n"